import { TECHNOLOGY } from '@constants/provider';

export function normalizeTechnology(technology?: string): TECHNOLOGY {
    const uppercasedTechnology = technology?.toUpperCase() as TECHNOLOGY;

    if (uppercasedTechnology === TECHNOLOGY.BOX_5G) {
        return TECHNOLOGY.BOX_4G;
    }

    return uppercasedTechnology;
}
